const WhyRegister = () => {
	return (
		<div className="why-register">
			<section className="gray_section" id="why-register">
				<div className="section_container">
					<div className="heading_section">
						<h3>Why Register? More Convenience. </h3>
						<p>Enjoy VIZIO benefits by signing up and registering your product. </p>
					</div>
					<div className="col_row">
						<div className="col_box">
							<div className="img_box">
								<em aria-hidden="true" className="vizio-icon icon-price-tag"></em>
							</div>
							<p>Access to Special Sales &amp; Offers</p>
						</div>
						<div className="col_box">
							<div className="img_box">
								<em aria-hidden="true" className="vizio-icon icon-invitation"></em>
							</div>
							<p>Invitation-only Reviewer Program</p>
						</div>
						<div className="col_box">
							<div className="img_box">
								<em aria-hidden="true" className="vizio-icon icon-tv"></em>
							</div>
							<p>First Look at New Technology</p>
						</div>
						<div className="col_box">
							<div className="img_box">
								<em aria-hidden="true" className="vizio-icon icon-support"></em>
							</div>
							<p>Easier Tech Support Check-in</p>
						</div>
						<div className="col_box">
							<div className="img_box">
								<em aria-hidden="true" className="vizio-icon icon-award"></em>
							</div>
							<p>Award Winning Customer Service</p>
						</div>
					</div>
				</div>
			</section>
		</div>
	);
};
export default WhyRegister;
